import { RootState } from "@/app/stores"
import { userAccrual } from "@/shared/api/users"
import { ErrorType, IBonusAccrualResponse } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

interface IUserAccrualRequest {
    bonus_id: string,
    amountNano: number
    comment: string,
}

export const fetchUserAccrual = createAsyncThunk<
    IBonusAccrualResponse,
    IUserAccrualRequest,
    { state: RootState }
>('userAccrual/fetchUserAccrual', async(data, thunkAPI) => {
    try {
        const { currentUser } = thunkAPI.getState().userAccrual
        const response = await userAccrual(currentUser.id, {
            bonus_id: data.bonus_id,
            amount_nano: data.amountNano,
            comment: data.comment,
        }) 
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})